import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { COTATIONS_URL } from "../../settings/APISetting";
import axiosInstance from "../../config/axiosConfig";

export const fetchCotations = createAsyncThunk('fetch-cotations', async () => {
    const response = await axiosInstance.get(COTATIONS_URL);
    return response.data;
});

export const createCotation = (cotation, err, cb) => {
    axiosInstance.post(COTATIONS_URL, cotation)
        .then((response) => {
            cb(response.data);
        })
        .catch(err);
}

export const deleteCotation = (id, err, cb) => {
    axiosInstance.delete(`${COTATIONS_URL}/${id}`)
        .then((response) => {
            cb(response.data);
        })
        .catch(err);
}


const cotationSlice = createSlice({

    name: 'cotations',
    initialState: { cotations: [], cotationsFetchStatus: '' },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchCotations.fulfilled, (state, action) => {

            state.cotationsFetchStatus = 'success';
            state.cotations = [...action.payload];
        }).addCase(fetchCotations.pending, (state, action) => {
            state.cotationsFetchStatus = 'loading';

        }).addCase(fetchCotations.rejected, (state, action) => {
            state.cotationsFetchStatus = 'error';

        });
    }


});
export default cotationSlice;